// extracted by mini-css-extract-plugin
export default {"card":"yR","cardrow":"zR","cardcentered":"AR","details":"BR","imgwrapper":"CR","img":"ER","category":"FR","name":"GR","copy":"HR","detailsbtn":"IR","remove":"JR","price":"KR","netPrice":"LR","regularPrice":"MR","label":"NR"};
    if(module.hot) {
      // 1713211523601
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  